<template>
    <div class="hamburguer">
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="black" v-bind="attrs" v-on="on">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-list-item><v-list-item-title>{{ $t('hamburguerMenu.api') }}</v-list-item-title></v-list-item>
                <v-list-item><v-list-item-title>{{ $t('hamburguerMenu.settings') }}</v-list-item-title></v-list-item>
                <v-list-item><v-list-item-title>{{ $t('hamburguerMenu.console') }}</v-list-item-title></v-list-item>
                <v-list-item><v-list-item-title>{{ $t('hamburguerMenu.profile') }}</v-list-item-title></v-list-item>
                <v-list-item style="cursor: pointer;" @click="handleLogout"><v-list-item-title>{{ $t('hamburguerMenu.logout') }}</v-list-item-title></v-list-item>
            </v-list>
        </v-menu>
    </div>

</template>

<script>
import { useAuthStore } from '@/store/authStore';

export default {
  methods: {
    handleLogout() {
      useAuthStore().logout();
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.hamburguer {
  display: none;
}
@media (max-width: 1200px) {
  .options {
    display: none;
  }
  .hamburguer {
    display: block;
  }
}
</style>